<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div id="w-center1400">
        <el-table
          v-loading="loading"
          show-summary
          class="table"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;"
          :summary-method="getSummaries"
          @selection-change="handleSelectionChange"
        >
              <el-table-column type="selection" min-width="10.5%" label="1">

                </el-table-column>
             <!-- <el-table-column label="商品预览" min-width="10.5%">
                <template slot-scope="scope">{{ scope.row.create_time }}</template>
              </el-table-column> -->
              <el-table-column
                prop="tm"
                label="书号"
                min-width="12%"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="gtitle"
                label="书名"
                min-width="20%"
                show-overflow-tooltip
              >
              </el-table-column>

              <el-table-column prop="cbs" label="出版社" min-width="15%">
                <template slot-scope="scope">
                  {{ scope.row.cbs}}
                </template>
              </el-table-column>

              <el-table-column prop="zz" label="作者" min-width="12%">
                <template slot-scope="scope">
                  {{ scope.row.zz}}
                </template>
              </el-table-column>
             <el-table-column prop="cbrq" label="出版日期" min-width="12%">
                <template slot-scope="scope">
                  {{ scope.row.cbrq}}
                </template>
              </el-table-column>
              <el-table-column prop="ztfl" label="中图分类" min-width="8%">
                <template slot-scope="scope">
                  {{ scope.row.ztfl}}
                </template>
              </el-table-column>


              <el-table-column prop="price" label="定价" min-width="8%">
                <template slot-scope="scope">
                  {{ scope.row.price}}
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量" min-width="15%">
                <template slot-scope="scope">
                  <el-input-number
                  @change="handleChange(scope.row.num,scope.row.id)"
                    size="mini"
                    v-model="scope.row.num"
                    :min="1"
                    label="描述文字"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="总价" min-width="13%">
                <template slot-scope="scope">
                  {{(scope.row.price * scope.row.num).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column  min-width="20%" align="right">

                <template slot="header" slot-scope="scope">
                  <el-button type="warning" size="small" style="float: left;" @click="xiugai()">修改数量</el-button>
                    <el-button
                      style="float: left;"
                      type="danger"
                      size="small"
                      @click="editfollowupForm"
                      >批量删除</el-button
                    >

                  </template>

                <template slot-scope="scope">

                  <el-button
                    type="text"
                    size="small"
                    class="deleteBtn"
                    icon="el-icon-delete"
                    @click="deletesc(scope.row.id)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>


            <el-dialog title="批量修改数量" :visible.sync="dialogFormVisible" width="30%">
              <el-form :model="form">
                <el-form-item label="数量" :label-width="formLabelWidth">
                  <el-input v-model="form.nums" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="oknums()">确 定</el-button>
              </div>
            </el-dialog>


      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      dialogFormVisible:false,
      loading:true,
      info:[],
      left:[],
      tableData:[],
      selNum:0,
      idss:'',
      formLabelWidth: '60px',
      form:{
        nums:''
      },
      id_s:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){

    this.recordapi();
  },

   //js
    watch: {
      tableData: function () {
        let _this = this;
        this.$nextTick(() => {
          // debugger;
          // console.log(_this.$refs.multipleTable.$refs);
          let html = _this.$refs.multipleTable.$refs.footerWrapper
            .querySelector(".el-table__footer")
            .querySelectorAll("td")[10]
            .querySelector(".cell");
          html.innerHTML = `   <button
              type="button"
              class="el-button el-button--default el-button--mini cart-btn"
              style="color: #fff; background: #f56c6c;width:120px;height:50px;font-size:20px"
            >
            <span>提交需求</span>
            </button>`;
           html.onclick=function(){
              console.log("点击",_this.totalPrice)
              console.log(_this.idss)

              var ids = '';
              var are = _this.id_s
               console.log(are)
              for (var i in are) {
                ids += are[i]['id']+",";
              }


              _this.g(ids);
           }


        });
      },
    },



  methods:{


    g(e){
      var that = this;
      console.log(e);
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Orderinfo/orderpost",{'userid':userid,'shopcart_ids':e}).then(res => {
        console.log(res);
        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
           setTimeout(this.$router.push('/Orderlist?index=3'), 1000);
        }else{
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      });

    },

    xiugai(){
     if(this.id_s == ''){
       this.$message({
         type: 'info',
         message: '请选择删除图书'
       });
       return;
     }

       this.dialogFormVisible = true;
    },

    // 批量修改数量
    oknums(){
      var nums =  this.form.nums

      var ids = '';
      var are = this.id_s
       console.log(are)
      for (var i in are) {
        ids += are[i]['id']+",";
      }



      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Shopcart/updateary",{'userid':userid,'nums':nums,'id':this.$encruption(ids.toString())}).then(res => {
        console.log(res);
        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.dialogFormVisible = false;
          this.recordapi();
        }else{
         this.$message.error(res.msg);
        }
      });



    },
    // 批量删除
    editfollowupForm(){


      if(this.id_s == ''){
        this.$message({
          type: 'info',
          message: '请选择删除图书'
        });
        return;
      }

      var ids = '';
      var are = this.id_s
       console.log(are)
      for (var i in are) {
        ids += are[i]['id']+",";
      }

      this.$confirm('此操作将永久删除该书籍, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Shopcart/deletepl",{'userid':userid,'id':this.$encruption(ids.toString())}).then(res => {
            console.log(res);
            if(res.code==1){
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.recordapi();
            }else{
             this.$message.error(res.msg);
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });



      console.log();
    },

    deletesc(id) {
        console.log(id);
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Shopcart/delete",{'userid':userid,'id':this.$encruption(id.toString())}).then(res => {
          console.log(res);
          if(res.code==1){
            this.$message({
              message: res.msg,
              type: 'success'
            });
             this.del(id);
          }else{
           this.$message.error(res.msg);
          }
        });

    },

    del(item){
      for (let i=0; i<this.tableData.length; i++){
        if (this.tableData[i]['id'] == item){
          this.tableData.splice(i, 1)
        }
      }
      console.log(this.tableData)
    },


    // 数量   数量/ 商品id
    handleChange(value,id) {
      console.log(value,id);
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Shopcart/num",{'userid':userid,'num':value,'id':this.$encruption(id.toString())}).then(res => {
        console.log(res);
        // if(res.code==1){
        //   this.$message({
        //     message: res.msg,
        //     type: 'success'
        //   });

        // }else{
        //   this.$message({
        //     message: res.msg,
        //     type: 'success'
        //   });
        // }
      });

    },
    // 多选
    handleSelectionChange(val) {
      var ids = [];
      this.selNum = val.length;
      this.id_s = val
      for (var index in val) {
        ids.push(val[index].id);
      }
      for (var i in this.tableData) {
        console.log(ids.indexOf(this.tableData[i].id))
        if (ids.indexOf(this.tableData[i].id) != -1) {
          this.tableData[i].selected = 1;
        } else {
          this.tableData[i].selected = 0;
        }
      }
    },
        getSummaries(param) {
          const { columns, data } = param;
          const sums = [];
          if (columns.length > 0) {
            console.log(this.tableData);
            this.totalPrice = this.tableData
              .filter((item) => item.selected == 1)
              .map((row) => row.num * row.price)
              .reduce((total, num) => total + num, 0)

              this.num = this.tableData
               .filter((item) => item.selected == 1)
              .map((row) => row.num)
              .reduce((total, num) => total + num, 0)
          } else {

            this.num = 0
            this.totalPrice = 0;
          }
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = "合计";
              return;
            }
            if (index === 2) {
              sums[index] = "已选中图书" + this.selNum + "件";
            }
            if (index === 8) {
              sums[index] = "总数量："+this.num ;
            }
            if (index === 9) {
              sums[index] = "总金额："+this.totalPrice.toFixed(2) + "元";
              return;
            }
            if (index == 10) {
            }
          });

          return sums;
      },




    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Shopcart/index",{'userid':userid}).then(res => {
          console.log(res);
          that.tableData= res.data.lists;
          // that.left= res.left;
          that.loading = false
        });
    },
    getCont(id){
      this.loading = true
      this.id=id;
      this.recordapi();
    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Goodscart.vue